
import { Component, Prop, Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import { emptyToLine } from "@common/src/utils/common";
import { addCurrencyUnit } from "@common/src/utils/tools";
import { namespace } from "vuex-class";
const service = namespace("service");
const setting = namespace("setting");
const inventory = namespace("inventory");
const store = namespace("store");
@Component({})
export default class OutWarehousePrint extends Vue {
  @service.Action getPrintStoreLogo;
  @setting.Action queryPrintFieldListByCategory;
  @inventory.Action queryOutWarehousePrintDetail;
  @store.State storeData;

  @Prop({ default: "", type: String })
  orderId: string;
  dayjs = dayjs;
  printLogo: string = "";
  // printLogo: string = "https://static.gtech.asia/static/speedbiz/speedbiz_logo.png";
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  orderData: any = {};
  get $orderData() {
    return this.orderData;
  }
  created() {
    this.getLogoImg();
    this.getPrintDetail();
    // this.getTemplateField();
  }
  getLogoImg() {
    this.getPrintStoreLogo().then(res => {
      this.printLogo = res.data.storeLogo || "";
    });
  }
  fieldList: any = [];
  get availableFieldArr() {
    return this.fieldList.filter(item => item.status === 1).map(item => item.fieldCode);
  }
  getTemplateField() {
    this.queryPrintFieldListByCategory({ category: "PRINT_DELEGATION_CREDENTIALS" }).then(data => {
      this.fieldList = this.$safeValue(data, "data.printFieldList", []);
    });
  }
  getPrintDetail() {
    if (this.orderId) {
      this.queryOutWarehousePrintDetail({
        outboundNo: this.orderId
      }).then(data => {
        this.orderData = data.data;
      });
    }
  }
}
